import { render } from "./emailMessage.vue?vue&type=template&id=8cf85608&scoped=true"
import script from "./emailMessage.vue?vue&type=script&lang=js"
export * from "./emailMessage.vue?vue&type=script&lang=js"

import "./emailMessage.vue?vue&type=style&index=0&id=8cf85608&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf85608"]])

export default __exports__